import { render, staticRenderFns } from "./CancelContentAction.vue?vue&type=template&id=f1737a22"
import script from "./CancelContentAction.vue?vue&type=script&lang=js"
export * from "./CancelContentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports